import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ArrowLeft from '../../../assets/svg/arrowLeft';
import ArrowRight from '../../../assets/svg/arrowRight';
import { colors } from 'kangarootime-ui';
import './WeekControl.css';

const WeekControl = ({ date, onNextWeek, onPreviousWeek, rightAreaComponent, leftAreaComponent }) => {
  const startOfWeek = moment(date).startOf('week');
  const endOfWeek = moment(date).endOf('week');

  const label = () => {
    return (
      <span><b>{startOfWeek.format('MMM')}</b><span> {startOfWeek.format('D')}</span> - <b>{endOfWeek.format('MMM')}</b><span> {endOfWeek.format('D')}</span></span>
    );
  };

  return (
    <div className='week-control-container'>
      <div className='week-control-left'>
        { leftAreaComponent }
      </div>
      <div className='week-control-center'>
        <div className='week-control-arrow-container' style={{ alignItems: 'center', marginRight: 32, display: 'grid' }} onClick={onPreviousWeek}>
          <ArrowLeft fill={colors.brand_3} />
        </div>
        <div style={{ alignItems: 'center', display: 'grid' }}>
          <span className='week-control-label'>{label()}</span>
        </div>
        <div className='week-control-arrow-container' style={{ alignItems: 'center', marginLeft: 32, display: 'grid' }} onClick={onNextWeek}>
          <ArrowRight fill={colors.brand_3} />
        </div>
      </div>
      <div className='week-control-right' style={{ gridTemplateColumns: '1fr' }}>
        { rightAreaComponent }
      </div>
    </div>
  );
};

WeekControl.propTypes = {
  date: PropTypes.instanceOf(Date),
  onNextWeek: PropTypes.func,
  onPreviousWeek: PropTypes.func,
  rightAreaComponent: PropTypes.instanceOf(Object), // should be a react component
  leftAreaComponent: PropTypes.instanceOf(Object) // should be a react component
};

export default WeekControl;
